var map = {
	"./webspecial_food_curry_cn.webm": 8154,
	"./webspecial_food_curry_de.webm": 2060,
	"./webspecial_food_curry_en.webm": 3880,
	"./webspecial_food_curry_ja.webm": 9894
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 3066;